module.exports = __webpack_public_path__ + "static/media/bg.70886dc0.png";